import { createReducer, on } from '@ngrx/store';
import { Combination } from '@shared/interfaces/combination/combination.interface';
import { CombinationFilterValues } from '@shared/interfaces/combination/combination-filters/combination-filters.interface';
import { Page } from '@shared/interfaces/pagination/page.interface';

import { userCombinations } from './user-combinations.actions';

export const userCombinationsFeatureKey = 'userCombinations';

export interface UserCombinationsState {
  filters: CombinationFilterValues;
  page: Page<Combination>;
  loading: boolean;
}

export const initialState: UserCombinationsState = {
  filters: {},
  page: { content: [] as Array<Combination> } as Page<Combination>,
  loading: false
};

export const userCombinationsReducer = createReducer<UserCombinationsState>(
  initialState,
  on(userCombinations.loadTableDataAndFilters, (state: UserCombinationsState) => ({
    ...state,
    loading: true
  })),
  on(userCombinations.cleanUpTableData, (state: UserCombinationsState) => ({
    ...state,
    loading: false
  })),
  on(
    userCombinations.loadTableAndDataFiltersSuccess,
    (
      state: UserCombinationsState,
      data: {
        page: Page<Combination>;
        filters: CombinationFilterValues;
      }
    ) => ({
      ...state,
      filters: { ...data.filters },
      page: data.page,
      loading: false
    })
  )
);
